export default __webpack_public_path__ + "static/avia_płatności_spark-c84febbb4466f9c07a6b7a82f0fcfe6d.jpg";